import React from 'react';
import { Center, Stack } from '@fiverr-private/layout_components';
import { Heading, Typography, Link } from '@fiverr-private/typography';
import { BillingCycleControl } from '../BillingCycleControl';
import { appTranslate } from '../../i18n';
import { Microsoft365Logo } from '../Icons/Microsoft365Logo';
import { ANCHOR_COMPARE_PACKAGES_SECTION } from '../../constants/anchors';
import { useIsDiscountPage } from '../../hooks';
import { DiscountBanner } from '../DiscountBanner';

export const ProductListingHeader = () => {
    const isDiscountPage = useIsDiscountPage();

    return (
        <Center rowGap="8" paddingX={{ default: '4', xl: '0' }} marginTop="4">
            <Center direction="column" rowGap="6">
                <Microsoft365Logo />

                <Stack direction="column" rowGap="2">
                    <Heading textAlign="center" as="h1" size="h_xxl">
                        {appTranslate('common.title')}
                    </Heading>
                    <Typography textAlign="center" maxWidth="605px" color="black">
                        {appTranslate('common.description')}
                    </Typography>
                </Stack>
            </Center>

            {!isDiscountPage && <BillingCycleControl />}

            <Link href={`#${ANCHOR_COMPARE_PACKAGES_SECTION}`} decoration="none" fontSize="b_sm" fontWeight="semibold">
                {appTranslate('package_details.title')}
            </Link>

            {isDiscountPage && <DiscountBanner />}
        </Center>
    );
};
